import { createSelector } from "reselect";

export const barcodeQtyImportReducerSelector = createSelector(
  state => state.get("barcodeQtyImportReducer"),
  barcodeQtyImportReducer => barcodeQtyImportReducer
);

export const hasErrorsSelector = createSelector(
  barcodeQtyImportReducerSelector,
  barcodeQtyImportReducer => barcodeQtyImportReducer.get("hasErrors")
);

export const dataSelector = createSelector(
  barcodeQtyImportReducerSelector,
  barcodeQtyImportReducer => barcodeQtyImportReducer.get("data")
);

export const fileUploadStatusSelector = createSelector(
  barcodeQtyImportReducerSelector,
  barcodeQtyImportReducer => barcodeQtyImportReducer.get("isUploadSuccesful")
);
